// @ts-nocheck
/* eslint-disable */
import { createEditPropsBtn } from "~/ui/mymaps/edit-props-btn";
import Content from './content';

/**
 * @class Horní nadpisová část vizitky
 * @private
 */
export default class Title extends Content {
	_build() {
		this._dom.container.classList.add("content-title");
		this._dom.h1 = Mapy.Util.node("h1");
		this._dom.container.appendChild(this._dom.h1);

		const likeData = this._data.likeData;

		// source coor
		if (this._isCoor) {
			this._setFormatTitle();
		} else {
			const likeTitle = (title: string) => {
				this._dom.h1.appendChild(Mapy.Util.text(title));
			};

			if (likeData?.usertitle) {
				likeTitle(likeData.usertitle);
			} else if (likeData?.title && likeData.title != this._data.origTitle) {
				likeTitle(likeData.title);
			} else {
				if(this._data.source == "closure") {
					this._dom.h1.classList.add("closure");
				}

				this._dom.h1.appendChild(Mapy.Util.text(this._data.title));
			}
		}

		if (likeData) {
			const editBtn = createEditPropsBtn({
				likeData,
				onSave: (newLikeData: Partial<IMapyBoxItem>) => {
					this._dom.h1.textContent = newLikeData.usertitle || likeData.title;
					this._data.onUpdate(newLikeData);
				},
			});

			this._dom.container.classList.add("has-edit-btn");
			this._dom.container.append(editBtn.container);
		}
	}

	_setFormatTitle() {
		var newTitle = this._gps.coordsToFormat(this._data.coords);
		this._dom.container.setAttribute("x-ms-format-detection", "none");

		if (this._data.userTitle) {
			this._dom.h1.appendChild(Mapy.Util.text(this._data.userTitle));
		}
		else {
			this._dom.h1.innerHTML = newTitle;
		}

		Mapy.getComponent("detail").changeTitle(this._data.userTitle ? this._data.userTitle : newTitle);
		Mapy.getComponent("detail").setSEO();
	}
}
